import React, { forwardRef, useEffect, useRef } from 'react';
import { motion, useIsPresent } from 'framer-motion';

// One step of the reply inside AnimatePresence. While it leaves it is inert, so
// its controls drop out of the tab order and the composer's focus handoff
// (useComposer) lands on the step coming in.
const ReplyStep = forwardRef(function ReplyStep(props, ref) {
  const present = useIsPresent();
  const node = useRef(null);
  useEffect(() => { node.current?.toggleAttribute('inert', !present); }, [present]);
  const attach = element => {
    node.current = element;
    if (typeof ref === 'function') ref(element); else if (ref) ref.current = element;
  };
  return <motion.div ref={attach} aria-hidden={present ? undefined : true} {...props} />;
});

export default ReplyStep;
